import Tree from "../tree";
import landingParser from "./landing/main-parser";
import landingLeftImageLayout from "./landing/left-image-parser";
import landingRightImageLayout from "./landing/right-image-parser";
import signupParser from "./signup/main-parser";
import signupLeftImageParser from "./signup/left-image-parser";
import signupRightImageParser from "./signup/right-image-parser";
import teaserParser from "./teaser-parser";

// convert to FormProperty type
const FORM_INPUT_TYPE_MAPPING = {
  "form-date": "date",
  "form-email": "email",
  "form-option": "option",
  "form-number": "numeric",
  "form-multi-option": "multi_option",
  "form-phone": "telephone",
  "form-openid": "openid",
  "form-text": "text",
  "form-textarea": "text",
  "form-url": "url",
  "form-dropdown": "select",
  "form-terms": "text",
  "form-rating": "text",
  "form-radio-grid": "grid_nonp",
};

export const getFormQuestions = (tree) => {
  const formQuestions = [];
  tree.traverseDF((item) => {
    if (item.type.startsWith("form-") && item.type !== "form-submit-button") {
      const label = (typeof item.data.label === 'string') ? item.data.label.trimStart() : (item.data.label || '');
      const question = {
        required: item.data.required || false,
        prop_key: item.id,
        label: label,
        input_type: FORM_INPUT_TYPE_MAPPING[item.type] || "text",
      };
      if (
        item.type === "form-dropdown" ||
        item.type === "form-option" ||
        item.type === "form-multi-option"
      ) {
        question.choices = item.data.options.map((opt) => opt.label);
      }
      if (item.type === "form-radio-grid") {
        question.choices = item.data.rows.map((x) => x.label);
        question.columns = item.data.cols.map((x) => x.value);
      }
      formQuestions.push(question);
    }
  });
  return formQuestions;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (treeData, preview = false) => {
  let tree;
  if (treeData instanceof Tree) {
    tree = treeData;
  } else {
    tree = new Tree(treeData.root);
  }


  const { parser, sideImage } = tree.root.data;
  
  let htmlParser = landingParser;

  if (!parser || parser === "landing") {
    if (sideImage === "leftImage") {
      htmlParser = landingLeftImageLayout;
    } else if (sideImage === "rightImage") {
      htmlParser = landingRightImageLayout;
    } else {
      htmlParser = landingParser;
    }
  } else if (parser === "signup_form" || parser === "signup_thankyou") {
    if (sideImage === "leftImage") {
      htmlParser = signupLeftImageParser;
    } else if (sideImage === "rightImage") {
      htmlParser = signupRightImageParser;
    } else {
      htmlParser = signupParser;
    }
  } else if (parser === "signup_teaser") {
    htmlParser = teaserParser
  }

  // return layout(tree);
  return htmlParser(tree, preview);

  // const data = tree.root;
  // const allRowsCompnentsHtml = data.children
  //   .map((node) => {
  //     return rowHtml(node, tree);
  //   })
  //   .join("");

  // let previewScript = "";
  // if (preview) {
  //   previewScript = `
  //     <script>
  //       document.querySelectorAll("a").forEach(function(ele) {
  //         var linkType = ele.dataset["linkType"];
  //         if (linkType === "anchor") {
  //           var arr = ele.href.split("#");
  //           var contentID = arr[arr.length-1];
  //           ele.href="javascript:void(0);";
  //           ele.onclick = function() {
  //             document.getElementById(contentID).scrollIntoView();
  //           };
  //         }
  //       });
  //     </script>
  //   `;
  // }

  // let googleAnalyticsScript = "";
  // if (tree.root.data.googleAnalyticsID) {
  //   googleAnalyticsScript = `
  //     <!-- Google tag (gtag.js) -->
  //     <script async src="https://www.googletagmanager.com/gtag/js?id=${
  //       tree.root.data.googleAnalyticsID || ""
  //     }"></script>
  //     <script>
  //       window.dataLayer = window.dataLayer || [];
  //       function gtag(){dataLayer.push(arguments);}
  //       gtag('js', new Date());
  //       gtag('config', '${tree.root.data.googleAnalyticsID || ""}');
  //     </script>
  //   `;
  // }

  // let metaKeywords = "";
  // if (tree.root.data.metaKeywords) {
  //   metaKeywords = `<meta name="keywords" content="${tree.root.data.metaKeywords}">`;
  // }
  // let metaDescription = "";
  // if (tree.root.data.metaDescription) {
  //   metaDescription = `<meta name="description" content="${tree.root.data.metaDescription}">`;
  // }

  // let metaRobots = "";
  // if (tree.root.data.metaNoFollow && tree.root.data.metaNoIndex) {
  //   metaRobots = `<meta name="robots" content="nofollow,noindex">`;
  // } else if (tree.root.data.metaNoFollow) {
  //   metaRobots = `<meta name="robots" content="nofollow,index">`;
  // } else if (tree.root.data.metaNoIndex) {
  //   metaRobots = `<meta name="robots" content="follow,noindex">`;
  // } else {
  //   metaRobots = `<meta name="robots" content="follow,index">`;
  // }

  // const { fieldsConfig, libsConfig, hasFormComponents } = getFormConf(tree);
  // const {
  //   contentAreaWidthMode,
  //   contentAreaWidthPercentage,
  //   sideImage,
  //   contentAreaWidth,
  //   sideImageUrl,
  //   sideImageSize,
  //   contentAreaBackgroundColor,
  //   sideContentAlignment,
  //   contentAreaAlignment,
  //   contentAreaVerticleAlignment,
  //   sideContentVerticleAlignment,
  //   shadowBlur,
  //   shadowColor,
  //   backgroundColor,
  // } = tree.root.data;

  // let contentWidth =
  //   contentAreaWidthMode === "percentage"
  //     ? `max-width: ${contentAreaWidthPercentage || 100}%;`
  //     : `max-width: ${contentAreaWidth}px;`;

  // let containerStr = "";
  // const rootPaddingStr = getPaddingString(tree.root.data);
  // const rootMarginStr = getMarginString(tree.root.data);
  // if (sideImage === "leftImage") {
  //   containerStr = `
  //       <div class="rip-mm-side-img-wrapper ${sideImageSize}">
  //         <img
  //           src="${sideImageUrl}"
  //           style="width: 100%;height: 100%;object-fit: cover;object-position: center center;"
  //         />
  //       </div>
  //       <div
  //         class="rip-mm-side-cnt-wrapper ${sideImageSize}"
  //         style="${rootPaddingStr}background-color: ${toRGBA(
  //     contentAreaBackgroundColor
  //   )};align-items: ${sideContentAlignment};justify-content: ${sideContentVerticleAlignment};"
  //       >
  //         ${allRowsCompnentsHtml}
  //       </div>
  //     `;
  // } else if (sideImage === "rightImage") {
  //   containerStr = `
  //       <div
  //         class="rip-mm-side-cnt-wrapper ${sideImageSize}"
  //         style="${rootPaddingStr}background-color: ${toRGBA(
  //     contentAreaBackgroundColor
  //   )};align-items: ${sideContentAlignment};justify-content: ${sideContentVerticleAlignment};"
  //       >
  //         ${allRowsCompnentsHtml}
  //       </div>
  //       <div class="rip-mm-side-img-wrapper ${sideImageSize}">
  //         <img
  //           src="${sideImageUrl}"
  //           style="width: 100%;height: 100%;object-fit: cover;object-position: center center;"
  //         />
  //       </div>
  //     `;
  // } else {
  //   containerStr = `
  //     <div
  //       class="rip-mm-side-cnt-wrapper"
  //       style="${rootPaddingStr}background-color: ${toRGBA(contentAreaBackgroundColor)}"
  //     >
  //       ${allRowsCompnentsHtml}
  //     </div>
  //     `;
  // }

  // const containerTag = hasFormComponents ? "form" : "div";

  // const htmlContent = `
  //   <!DOCTYPE html>
  //   <html>
  //     <head><meta charset="UTF-8">
  //       <title>${tree.root.data.pageTitle || ""}</title>
  //       <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no">
  //       ${metaKeywords}
  //       ${metaDescription}
  //       ${metaRobots}
  //       ${layoutStyle}
  //     <script>
  //       function setCookie(name, value, timestamp) {  
  //         var expires = "";  
  //         if (days) {  
  //             var date = new Date();  
  //             date.setTime(timestamp);  
  //             expires = "; expires=" + date.toUTCString();  
  //         }  
  //         document.cookie = name + "=" + (value || "")  + expires + "; path=/";  
  //       }
  //       function getCookie(name) {  
  //         let matches = document.cookie.match(new RegExp(  
  //             "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$&') + "=([^;]*)"  
  //         ));  
  //         return matches ? decodeURIComponent(matches[1]) : undefined;  
  //       }
  //       var pendingIntervalIds = [];
  //       window.onclose = function() {console.log("windows close");}
  //     </script>
  //       ${googleAnalyticsScript}
  //     <script src="https://cdn.jsdelivr.net/npm/jquery@3.3.1/dist/jquery.min.js"></script>
  //     <script src="https://cdn.jsdelivr.net/npm/jquery-validation@1.19.5/dist/jquery.validate.min.js"></script>
  //     <script src="https://cdn.jsdelivr.net/npm/rip-stars-rating@1.0.1/build/main.js"></script>
  //     ${hasFormComponents ? formBasicScript : ""}
  //     ${
  //       libsConfig.ripPhoneLib
  //         ? `<script src="https://cdn.jsdelivr.net/npm/libphonenumber-js@1.10.24/bundle/libphonenumber-js.min.js"></script>
  //            <script>
  //             jQuery.validator.addMethod("ripPhoneNo", function(value, element) {
  //               var codeId = element.id + "-code";
  //               var code =$("#" + codeId).val();
  //               if (!value) return true;
  //               try {
  //                 return libphonenumber.parsePhoneNumber('+' + code + value).isValid();
  //               } catch (error) {
  //                 return false;
  //               }
  //             }, "Please enter a valid phone number.");
  //            </script>`
  //         : ""
  //     }
  //     ${
  //       libsConfig.ripTermsLib
  //         ? `<script src="https://cdn.jsdelivr.net/npm/jquery-popup-overlay@2.1.5/jquery.popupoverlay.min.js"></script>`
  //         : ""
  //     }
  //     ${libsConfig.countdownLib ? countdownBasicScript : ""}
  //     <script>
  //         var config = ${JSON.stringify(fieldsConfig)};
  //         jQuery.validator.addMethod("ripFormType", function() {
  //           return true;
  //         }, "Internal use.");
  //     </script>
  //     </head>
  //     <body style="font-family:${
  //       tree.root.data.defultFont
  //     };font-size: 14px;background-color: ${toRGBA(backgroundColor)}">
  //       <${containerTag}
  //         id="rip-mm-contaier"
  //         style="height: 100%;width: 100%;display: flex;justify-content: ${contentAreaAlignment};align-items: ${contentAreaVerticleAlignment};"
  //       >
  //         <div
  //           class="preview-container"
  //           id="preview-container"
  //           style="width: 100%;display: flex;${contentWidth}${rootMarginStr}background-color: ${toRGBA(backgroundColor)};box-shadow: 0 0 ${shadowBlur}px ${toRGBA(shadowColor)}"
  //         >
  //           ${containerStr}
  //         </div>
  //       </${containerTag}>
  //     </body>
  //     ${previewScript}
  //     <script>
  //       function handleFetchSuccess() {
  //         var pathname = window.location.pathname;
  //         var splitted = pathname.split("/");
  //         if (pathname.substr(-1) !== '/') {
  //           splitted[splitted.length - 2] = "thankyou";
  //         } else {
  //           splitted[splitted.length - 3] = "thankyou";
  //         }
  //         var thankyouUrl = splitted.join("/");
  //         var verRegEx = new RegExp("[?&]v=([^&#]*)").exec(window.location.search);
  //         if (verRegEx && verRegEx.length >= 1) {
  //             thankyouUrl += "/?v=" + verRegEx[1];
  //         }
  //         window.location = thankyouUrl;
  //       }

  //       function handleFetchComplete(data, status) {
  //         if (status == "success") {
  //           handleFetchSuccess();
  //         }
  //       }
  //       $("#form-submit-button").on("click", function() {
  //         if (validator.form()) {
  //             var data = getData();
  //             console.log(data)
  //             var pathname = window.location.pathname;
  //             var splitted = pathname.split("/");
  //             let formId = splitted[splitted.length - 2];
  //             if (pathname.substr(-1) !== '/') {
  //                 formId = splitted[splitted.length - 1];
  //             }

  //             var pathname = window.location.pathname;
  //             var splitted = pathname.split("/");
  //             var isPreview = splitted[2] === "preview";

  //             data.is_preview = isPreview;
  //             $.ajax({
  //                 complete: handleFetchComplete,
  //                 contentType: "application/json",
  //                 dataType: "json",
  //                 type: "POST",
  //                 data: JSON.stringify(data),
  //                 url: "/api/content_management/cnt_form/submit/" + formId + "/"
  //             });
  //           }
  //       });
  //     </script>
  //   </html>
  // `;
  // return htmlContent;
};
